<template src="./template.html"></template>
<script>
import CANNABIS_TYPES from 'constants/cannabisTypes'
import CANNABIS_TYPE_NAMES from 'constants/cannabisTypeNames'

export default {
  name: 'cannabis-type-label',
  props: {
    cannabisType: {
      type: String,
      required: true,
    },
    simple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        [`type-${this.cannabisType.toLowerCase()}`]: true,
        simple: this.simple,
      }
    },
  },
  data() {
    return {
      CANNABIS_TYPES,
      CANNABIS_TYPE_NAMES,
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/CannabisTypeLabel/index.vue